import { createContext } from 'react';

const SectionContext = /** @__PURE__ */ createContext({
    justify: "left",
});

export { SectionContext };
